import { put } from 'redux-saga/effects'
import importer from 'common/importer'
const AppointmentsActions = importer('Stores/Appointments/Actions')
export default function * success (res) {
  // console.log(res)
  yield put(AppointmentsActions.updateGiftCardPreferenceSuccess(null))
  yield put(AppointmentsActions.updateGiftCardPreferenceFailure(null))
}
